import { mergeClasses } from "@coreai/fluentui-react";
import { WorkflowRunsPanelStyles } from "./WorkflowRunsPanel.styles";

export const RunCardSkeleton = () => {
  const styles = WorkflowRunsPanelStyles();
  return (
    <div className={styles.skeletonCard}>
      <div className={mergeClasses(styles.skeletonDot, styles.skeletonPulse)} />
      <div className={styles.skeletonContent}>
        <div className={mergeClasses(styles.skeletonLine, styles.skeletonLinePrimary, styles.skeletonPulse)} />
        <div className={mergeClasses(styles.skeletonLine, styles.skeletonLineSecondary, styles.skeletonPulse)} />
      </div>
      <div className={mergeClasses(styles.skeletonDuration, styles.skeletonPulse)} />
    </div>
  );
};